import { forwardRef, type Ref, type SVGProps } from "react";
const IconWindOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15.263 28q-1.009 0-1.852-.529a3.9 3.9 0 0 1-1.356-1.461q-.207-.356.01-.728a.69.69 0 0 1 .63-.371.7.7 0 0 1 .409.13q.183.131.309.34.297.477.795.776.497.299 1.055.299.91 0 1.56-.682t.65-1.635-.65-1.636-1.56-.681H2.737a.7.7 0 0 1-.526-.221.77.77 0 0 1-.211-.552q0-.33.211-.55a.7.7 0 0 1 .526-.222h12.526q1.53 0 2.608 1.129 1.076 1.128 1.076 2.733 0 1.604-1.076 2.732-1.078 1.13-2.608 1.129M2.737 13.267a.7.7 0 0 1-.526-.221.77.77 0 0 1-.211-.551q0-.33.211-.551a.7.7 0 0 1 .526-.221h18.42q1.206 0 2.077-.914.87-.913.871-2.175 0-1.263-.871-2.176t-2.076-.913q-.873 0-1.601.482a2.9 2.9 0 0 0-1.08 1.32q-.117.226-.286.37a.6.6 0 0 1-.403.144.79.79 0 0 1-.644-.312.69.69 0 0 1-.112-.7q.515-1.326 1.634-2.087A4.33 4.33 0 0 1 21.158 4q1.854 0 3.137 1.346 1.284 1.346 1.284 3.288t-1.284 3.288-3.137 1.345zm24.639 11.656a.69.69 0 0 1-.729-.082.81.81 0 0 1-.331-.685q0-.243.137-.417.138-.174.353-.295a2.8 2.8 0 0 0 1.26-1.132q.46-.765.46-1.678 0-1.263-.871-2.176t-2.076-.913H2.737a.7.7 0 0 1-.526-.222.77.77 0 0 1-.211-.55q0-.33.211-.552A.7.7 0 0 1 2.737 16h22.842q1.854 0 3.137 1.346Q30 18.69 30 20.634a4.87 4.87 0 0 1-.697 2.567 4.3 4.3 0 0 1-1.927 1.722" />
  </svg>
);
const ForwardRef = forwardRef(IconWindOutlineSVG);
ForwardRef.displayName = "IconWindOutline";
export { ForwardRef as IconWindOutline };
